import axios from 'axios';
import * as webfontloader from 'webfontloader';
import { sortBy, prop } from 'ramda';

const FONTS_BASE_URL = process.env.VUE_APP_FONTSERVICE;

class FontService {
  constructor() {
    this.http = axios.create({
      baseURL: FONTS_BASE_URL
    });
  }

  getAll() {
    return this.http.get('/api/font/polle').then(({ data }) => {
      return sortBy(prop('name'), data.fonts).reverse();
    });
  }

  load() {
    return this.getAll().then(fonts => {
      return new Promise(resolve => {
        webfontloader.load({
          custom: {
            families: fonts.map(font => font.name),
            urls: [`${FONTS_BASE_URL}/api/css/polle`]
          },
          fontactive() {
            resolve(fonts);
          }
        });
      });
    });
  }
}

export default new FontService();
